import React, { useState, useEffect } from 'react'
import Axios from 'axios'
import { getUser } from '../../actions/session'
import { MONETARY_STATS_GRAPH } from '../../config/rest_endpoints'
import LineGraph from '../common/graphs/lineGraph'
import VerticalBarGraph from '../common/graphs/verticalBar'
import DatePicker from "react-datepicker";
import { Notifications } from '../common/notification'
import Select from 'react-select';


const MultiGraph = () => {
  const [stats, setStat] = useState({
    dates: [],
    cost: [],
    profit: [],
    revenue: []
  })
  const [statsSums, setStatSums] = useState({
    cost: [],
    profit: [],
    revenue: []
  })
  const [selectInterval, setSelectInterval] = useState({ value: 'week', label: 'week' })
  const [intervalOptions] = useState([
      { value: 'week', label: 'week' },
      { value: 'fortnight', label: 'fortnight' },
       { value: 'month', label: 'month' },
      { value: 'half-year', label: 'half-year' },
      { value: 'year', label: 'year' }
    ])
    const [User] = useState(getUser())

  useEffect(() => {
    getStats()
  }, [selectInterval])

  const handleSelectInterval = (selectInterval) => {
    setSelectInterval(selectInterval)
  }

  const getStats = () => {
    var payload = {
      "statsDur": selectInterval.value
    }
    var headers = { 'Authorization': "Bearer " + User.token }
    Axios.post(MONETARY_STATS_GRAPH, payload, { headers }).then(res => {
      if (res) {
        let data = res.data.data
        let setDate = data.date.map(da => da.split('T')[0])
        const costSum = data.cost.reduce((a, b) => a + b, 0)
        const profitSum = data.profit.reduce((a, b) => a + b, 0)
        const revenueSum = data.revenue.reduce((a, b) => a + b, 0)
        setStatSums({
          cost: costSum.toFixed(3),
          profit: profitSum.toFixed(3),
          revenue: revenueSum.toFixed(3)
        })
        setStat({
          dates: setDate,
          cost: data.cost,
          profit: data.profit,
          revenue: data.revenue
        })
      }
    }).catch(err => {
      const alert = err.response
      Notifications.notify(alert.data.message, "Failed", "error")

    })
  }


  return (
    <div className="row">
      <div className="col-md-12">
        {/* Sales stats */}
        <div 
        style={{borderRadius:'5px',boxShadow:'0 0 20px rgba(0,0,0,.2)',border:'none'}}
        className="bg-white card border-left-dark-alpha border-right-dark-alpha">
          <h4 
          style={{backgroundColor:'white',fontWeight:'',color:'#212529',fontSize:'22'}} 
          className="m-2 card-title mr-auto theme-title-design ml-0"
          >
          System Monetary Stats
          </h4>
          <div className=" card-header header-elements-sm-inline py-sm-1">
            <h3 className="card-title mr-auto"></h3>
            <div className=" header-elements">
              <div className=" form-group mb-2 mr-4">
                <div class="input-group d-flex justify-content-around">
                    <Select
                      value={selectInterval}
                      onChange={handleSelectInterval}
                      options={intervalOptions}
                      className="w-20em"
                      // style ={{maxWidth:'100%'}}
                    />
                </div>
              </div>
            </div>
          </div>
          {/* <div className="row">
            <div className="col-lg-6 offset-lg-8">
              
            </div>
          </div> */}
          <div className="card-body py-0">
            <div className="row text-center">
              <div className="col-sm-4">
                <div className="mb-2">
                <span
                  style={{fontSize:'16px',fontWeight:'600',color:'#868e96'}}
                  className="text-muted fs-14">Sum of Cost
                  </span>
                  <h5
                  style={{fontSize:'13px'}}
                  className="font-weight-semibold mb-0">{statsSums.cost}
                  </h5>
                </div>
              </div>
              <div className="col-sm-4">
                <div className="mb-2">
                  <span style={{fontSize:'16px',fontWeight:'600',color:'#868e96'}} className="text-muted fs-14">Sum of Profit</span>
                  <h5 style={{fontSize:'13px'}} className="font-weight-semibold mb-0">{statsSums.profit}</h5>
                </div>
              </div>
              <div className="col-sm-4">
                <div className="mb-2">
                  <span style={{fontSize:'16px',fontWeight:'600',color:'#868e96'}} className="text-muted fs-14">Sum of Revenue</span>
                  <h5  style={{fontSize:'13px'}} className="font-weight-semibold mb-0">{statsSums.revenue}</h5>
                </div>
              </div>
            </div>
          </div>
          <div className="chart mb-2" id="app_sales">
            <div className=" pl-4 pr-4 pt-2 pb-3">
              <LineGraph title="Cost" title1="Profit" title2="Revenue" x={stats.dates} y={stats.cost} y1={stats.profit} y2={stats.revenue} width={700} height={300} lineColor="#ff5722" lineColor1="#4caf50" lineColor2="#5c6bc0" />
            </div>
          </div>
        </div>
        {/* /sales stats */}
      </div>
      {/* <div className="col-md-6">
        <div className="card">
          <div className="card-header header-elements-sm-inline py-sm-1">
            <h6 className="card-title py-sm-3 fs-20">Sessions statistics</h6>
            <div className="header-elements">
              <select className="form-control custom-select" id="select_date">
                <option value="val1">June, 29 - July, 5</option>
                <option value="val2">June, 22 - June 28</option>
                <option value="val3" selected>June, 15 - June, 21</option>
                <option value="val4">June, 8 - June, 14</option>
              </select>
            </div>
          </div>
          <div className="card-body py-0">
            <div className="row text-center">
              <div className="col-4">
                <div className="mb-3">
                  <h5 className="font-weight-semibold mb-0">5,689</h5>
                  <span className="text-muted font-size-sm">new orders</span>
                </div>
              </div>
              <div className="col-4">
                <div className="mb-3">
                  <h5 className="font-weight-semibold mb-0">32,568</h5>
                  <span className="text-muted font-size-sm">this month</span>
                </div>
              </div>
              <div className="col-4">
                <div className="mb-3">
                  <h5 className="font-weight-semibold mb-0">$23,464</h5>
                  <span className="text-muted font-size-sm">expected profit</span>
                </div>
              </div>
            </div>
          </div>
          <div className="chart mb-2" id="app_sales">
            <div className="pl-4 pr-4 pt-2 pb-3">
              <LineGraph title="Sessions" secondTitle="CPS" x={stats.n1} y={stats.n2} a={stats.n3} width={800} height={300} lineColor="blue" />
            </div>
          </div>
        </div>
      </div> */}
    </div>
  )
}

export default MultiGraph